import { el, setAttr } from 'redom';

import application from 'application';

import internalEventCodes from 'event-system/codes/internal';
import externalEventCodes from 'event-system/codes/external';

import HelptapEditor from '../../../helpers';

import { stringToSVG } from 'utilities';

import LabelDialog from './label-dialog';

import favouriteNodeIconString from 'assets/images/favourite-node-icon.svg?raw';

const favouriteNodeIcon = stringToSVG(favouriteNodeIconString);

class FavouriteNodeButton {

  constructor(menu, configuration) {

    this.menu = menu;

    this.editor = configuration.editor;
    this.node = { ...configuration.node };
    this.parentEntityId = configuration.parentEntityId;
    this.activeNodePath = configuration.activeNodePath;

    const buttonStatus = this.computeButtonStatus();

    this.buttonLabel = el('label', buttonStatus.text);

    this.el = el('button.favourite-node-button', {
      class: buttonStatus.class,
      type: 'button',
      onclick: this.handleButtonClick.bind(this)
    }, [favouriteNodeIcon.cloneNode(true), this.buttonLabel]);

  }

  validateFavouritePageNodeId() {

    const favouritePageNodeId = this.node.favouritePageNodeId;

    if (typeof favouritePageNodeId !== 'string') {
      return;
    }
    if (application.favouritePageNodesManager.isFavouritePageNodeExistsById(favouritePageNodeId) === true) {
      return;
    }

    this.node.favouritePageNodeId = null;

    this.updateButtonStatus();

    this.unmarkFavouriteNode();

  }

  onmount() {
    application.eventSystem.internal.eventFor(this, externalEventCodes.FAVOURITE_PAGE_NODE_DELETED, this.handleFavouritePageNodeDeletedEvent.bind(this));

    this.validateFavouritePageNodeId();

  }

  onunmount() {
    application.eventSystem.internal.offAllOn(this);
  }

  handleFavouritePageNodeDeletedEvent(payload) {

    if (this.node.favouritePageNodeId !== payload.favouritePageNodeId) {
      return;
    }

    this.unmarkFavouriteNode();

  }

  computeButtonStatus() {

    let cls = 'favourite-node-button';
    let text = 'Favorite';

    const favouritePageNodeId = this.node.favouritePageNodeId;

    if (typeof favouritePageNodeId === 'string' && application.favouritePageNodesManager.isFavouritePageNodeExistsById(favouritePageNodeId) === true) {
      cls += ' favourited-node';
      text = 'Unfavorite';
    }

    const status = {
      class: cls,
      text
    };

    return status;

  }

  async createFavouritePageNode() {

    const editor = this.editor;
    const node = this.node;
    const pageId = this.parentEntityId;
    const activeNodePath = this.activeNodePath;

    const labelResult = await application.dialogsManager.display(LabelDialog);

    if (labelResult.cancelled === true) {
      return;
    }

    const label = labelResult.value.label;
    const isPublic = labelResult.value.public;
    const favouritePageNode = {
      label,
      description: label,
      pageId,
      node,
      nodeType: node.type,
      public: isPublic
    };

    try {

      const _favouritePageNode = await application.favouritePageNodesManager.create(favouritePageNode);

      HelptapEditor.setAttributes(editor, {
        favouritePageNodeId: _favouritePageNode._id
      }, activeNodePath);

      application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
        message: 'Node favourited',
        seconds: 5,
        type: 'info'
      });

    } catch (exception) {

      application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
        message: 'Unable to favourite node',
        seconds: 5,
        type: 'error'
      });

    } finally {

    }

  }

  async unmarkFavouriteNode() {

    const editor = this.editor;
    const node = this.node;
    const activeNodePath = this.activeNodePath;
    const favouriteNodeId = node.favouritePageNodeId;

    await application.favouritePageNodesManager.delete(favouriteNodeId);

    HelptapEditor.setAttributes(editor, {
      favouritePageNodeId: null
    }, activeNodePath);

  }

  async handleButtonClick() {

    this.menu.onClose();

    if (typeof this.node.favouritePageNodeId !== 'string') {
      await this.createFavouritePageNode();
    } else {
      await this.unmarkFavouriteNode();
    }

    this.updateButtonStatus();

  }

  updateButtonStatus() {

    const buttonStatus = this.computeButtonStatus();

    setAttr(this.el, {
      class: buttonStatus.class
    });

    this.buttonLabel.textContent = buttonStatus.text;

  }

  update(configuration) {

    this.editor = configuration.editor;
    this.node = { ...configuration.node };
    this.parentEntityId = configuration.parentEntityId;
    this.activeNodePath = configuration.activeNodePath;

    this.updateButtonStatus();

  }

}

export default FavouriteNodeButton;